module.exports = __webpack_public_path__ + "fonts/Inter-800-greek-ext73.318d4ba.woff2";